/**
 * The one age ramp: how old a waiting item is, and the chip colour for it.
 *
 * Shared by the desk's rows and the notification panel, and on the same
 * cool-to-hot scale as AgingBar (MyDesk.tsx), so a chip, the bar and the bell
 * can never disagree about what counts as old. Do not add a second ramp.
 *
 * The server mirrors these thresholds for the bell's `severity`
 * (backend/services/actionItems/severity.ts: warning at 1 day, overdue at 3 or
 * past due). Change one, change the other.
 */

/** Whole days since `d`; 0 for a missing or unreadable date. */
export function ageDays(d: string | null | undefined): number {
  const t = new Date(d || '');
  if (Number.isNaN(t.getTime())) return 0;
  const ms = Date.now() - t.getTime();
  return Math.max(0, Math.floor(ms / (1000 * 60 * 60 * 24)));
}

/** Chip colours by age. A week or more gets its own, stronger band. */
export function ageChipClass(days: number): string {
  if (days >= 7) return 'bg-red-100 text-red-800';
  if (days >= 3) return 'bg-red-50 text-red-700';
  if (days >= 1) return 'bg-amber-50 text-amber-700';
  return 'bg-blue-50 text-blue-700';
}

/** "Today", "1d", "12d" — the chip's text. */
export function ageLabel(days: number): string {
  return days === 0 ? 'Today' : `${days}d`;
}
